import React from 'react';

import { ELMA365ComponentChangeModelOutput } from '../../../../../../../gamma-api';
import { getTranslateFunc } from '../../../../../../utils/stringUtil';
import IbModal, { IbModalPosition } from '../../../../../../components/common/IbModal';
import IbButton from '../../../../../../components/common/IbButton';
import IbTooltip from '../../../../../../components/common/IbTooltip';
import ChangeTable from '../../ChangeTable';

import './index.less';

import { MAIN_CLASS_NAME } from './const';

interface IChangesModalProps {
  visible: boolean;
  loading?: boolean;
  changes?: ELMA365ComponentChangeModelOutput[];
  toggledKeys?: { [key: string]: boolean };
  onToggle?: (key: string, selected: boolean) => void;
  onFinish?: () => void;
  onCancel?: () => void;
}

const ChangesModal: React.FC<IChangesModalProps> = ({
  visible,
  loading,
  changes,
  toggledKeys,
  onToggle,
  onFinish,
  onCancel,
}) => {
  const translate = getTranslateFunc('Toolkits: ELMA365: Merge: Changes:');

  const renderFinishButton = () => {
    const disabled = !toggledKeys || !Object.values(toggledKeys).some((selected) => selected);

    const button = (
      <IbButton disabled={disabled} type="primary" onClick={onFinish}>
        {translate('Finish: Title')}
      </IbButton>
    );

    if (!disabled) {
      return button;
    }

    return <IbTooltip title={translate('Finish: Disabled')}>{button}</IbTooltip>;
  };

  const renderCancelButton = () => {
    return (
      <IbButton type="secondary" onClick={onCancel}>
        {translate('Cancel: Title')}
      </IbButton>
    );
  };

  const renderContent = () => {
    return <ChangeTable changes={changes} toggledKeys={toggledKeys} onToggle={onToggle} />;
  };

  const renderFooter = () => {
    return (
      <>
        {renderFinishButton()}
        {renderCancelButton()}
      </>
    );
  };

  return (
    <IbModal
      className={MAIN_CLASS_NAME}
      footer={renderFooter()}
      loading={loading}
      position={IbModalPosition.FullHeight}
      title={translate('Title')}
      visible={visible}
      width={'75%'}
      onCancel={onCancel}
    >
      {renderContent()}
    </IbModal>
  );
};

export default ChangesModal;
